import React, { useEffect, useState } from "react";
import "./setup.scss";
import { getOfflineData } from "../../utils/offline-services";
import { useNavigate } from "react-router-dom";
import MuiTable from "../../component/mui-table";
import { getKowledgeBaseHeaderConfig, getNewsHeaderConfig } from "./config";
import { Box, Button, TextField, Typography } from "@mui/material";
import { HTTP_METHODS, invokeApi } from "../../utils/http-service";
import CustomModal from "../../component/modal";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import { toast } from "react-toastify";
import DeleteModal from "../../core/delete-modal";

const AdminNews = () => {
  const [formData, setFormData] = useState({});
  const [data, setData] = useState({});
  const [filters, setFilters] = useState({
    sortBy: "-createdAt",
    page: 1,
    limit: 10,
  });
  const [editNews, setEditNews] = useState({
    isOpen: false,
    data: {},
  });
  const [readMoreModal, setReadMoreModal] = useState({
    isOpen: false,
    text: "",
  });
  const [deleteModal, setDeleteModal] = useState({ isOpen: false, data: {} });
  const navigate = useNavigate();
  const user = getOfflineData("user");
  const updateHandler = (data, type) => {
    switch (type) {
      case "EDIT":
        setEditNews({
          isOpen: true,
          data: data,
        });
        setFormData({
          title: data.title,
          date: new Date(data.date).toISOString().split("T")[0],
          desc: data.desc,
        });
        break;
      case "DELETE":
        setDeleteModal({
          isOpen: true,
          data: data,
        });
        break;
      default:
        break;
    }
  };
  const updateNews = () => {
    const payload = {};
    for (let i in formData) {
      if (formData[i]) {
        payload[i] = formData[i];
      }
    }

    if (editNews?.data?.id) {
      invokeApi(
        HTTP_METHODS.PUT,
        `${HOSTNAME}${REST_URLS.NEWS}/${editNews.data.id}`,
        payload
      )
        .then((res) => {
          if (res.message) {
            toast.error(res.message, { autoClose: 2000 });
          } else {
            toast.success("Updated Successfully", { autoClose: 1000 });
            setFormData({});
            setEditNews({
              isOpen: false,
              data: {},
            });
            getData({ ...filters, page: 1 });
          }
        })
        .catch((err) => console.error(err));
    } else {
      invokeApi(HTTP_METHODS.POST, `${HOSTNAME}${REST_URLS.NEWS}`, payload)
        .then((res) => {
          if (res.message) {
            toast.error(res.message, { autoClose: 2000 });
          } else {
            toast.success("Created Successfully", { autoClose: 1000 });
            setFormData({});
            setEditNews({
              isOpen: false,
              data: {},
            });
            getData({ ...filters, page: 1 });
          }
        })
        .catch((err) => console.error(err));
    }
  };
  const getData = (filter) => {
    invokeApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.NEWS}`, null, filter)
      .then((res) => {
        if (res.message) {
          toast.error(res.message, { autoClose: 2000 });
        } else {
          setData(res);
        }
      })
      .catch((err) => console.error(err));
  };
  const readMoreFunc = (data) => {
    setReadMoreModal(data);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevVal) => ({ ...prevVal, [name]: value }));
  };
  const deleteHandler = () => {
    if (deleteModal?.data?.id) {
      invokeApi(
        HTTP_METHODS.DELETE,
        `${HOSTNAME}${REST_URLS.NEWS}/${deleteModal?.data?.id}`
      )
        .then((res) => {
          if (res.message) {
            toast.error(res.message, { autoClose: 2000 });
            setDeleteModal({
              isOpen: false,
              data: {},
            });
          } else {
            toast.success("Deleted Successfully", { autoClose: 2000 });
            setDeleteModal({
              isOpen: false,
              data: {},
            });
            getData({ ...filters, page: 1 });
          }
        })
        .catch((err) => console.error(err));
    }
  };
  useEffect(() => {
    if (user?.role !== "admin") {
      navigate("/");
    }
  }, []);
  useEffect(() => {
    getData(filters);
  }, []);
  return (
    <div>
      <div className="users-con">
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h5" className="primary-text">
            News
          </Typography>
          <Button
            size="small"
            variant="outlined"
            sx={{ mb: 1 }}
            onClick={() => {
              setEditNews({ isOpen: true, data: {} });
            }}
          >
            Add News
          </Button>
        </div>

        <MuiTable
          columnsList={getNewsHeaderConfig()}
          dataList={data?.results || []}
          filters={filters}
          pageCount={data?.totalPages}
          onClick={updateHandler}
          maxWords="9"
          showAllFunc={readMoreFunc}
          onChange={(page) => {
            setFilters({
              ...filters,
              page,
            });
            getData({
              ...filters,
              page,
            });
          }}
        ></MuiTable>

        {data?.results?.length === 0 && (
          <Typography variant="h4" sx={{ textAlign: "center" }}>
            News Not Found
          </Typography>
        )}
        {editNews.isOpen && (
          <CustomModal
            title={editNews?.data.id ? "Edit News" : "Create News"}
            onClose={() => {
              setEditNews({
                isOpen: false,
                data: {},
              });
              setFormData({});
            }}
            contentClassName="set-modal-styles"
          >
            <Box sx={{ gridGap: "12px", display: "grid" }}>
              <TextField
                label="Title"
                name="title"
                size="small"
                value={formData?.title}
                onChange={handleChange}
                fullWidth
              />
              <TextField
                label="Publish Date"
                name="date"
                size="small"
                value={formData?.date}
                type="date"
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={handleChange}
                fullWidth
              />
              <TextField
                label="Description"
                name="desc"
                size="small"
                value={formData?.desc}
                onChange={handleChange}
                fullWidth
                multiline
                minRows={5}
              />

              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  onClick={updateNews}
                  disabled={!formData?.title || !formData?.desc}
                  sx={{ mb: 5 }}
                >
                  Save
                </Button>
              </div>
            </Box>
          </CustomModal>
        )}
        {readMoreModal?.isOpen && (
          <CustomModal
            onClose={() => {
              setReadMoreModal({
                isOpen: false,
                text: "",
              });
            }}
            contentClassName="set-modal-styles"
          >
            <Typography variant="body1">{readMoreModal?.text}</Typography>
          </CustomModal>
        )}
        {deleteModal?.isOpen && (
          <DeleteModal
            onClose={() =>
              setDeleteModal({
                isOpen: false,
                data: {},
              })
            }
            deleteFunc={deleteHandler}
          />
        )}
      </div>
    </div>
  );
};

export default AdminNews;
